import { service } from 'services';
import { basicCRUDAction, hotGetAction } from 'utils';
import { ACTIONS_TYPES } from '../helper';

const applicationloadbalancers = {
  getAll: async ({ dcId }) => hotGetAction({
    action: ACTIONS_TYPES.APPLICATION_LOAD_BALANCER.GET_ALL,
    apiResult: service.applicationLoadbalancer.getAll({ dcId }),
    isRetrieveItems: true,
  }),
  get: async ({ dcId, id }) => hotGetAction({
    action: ACTIONS_TYPES.APPLICATION_LOAD_BALANCER.GET,
    apiResult: service.applicationLoadbalancer.get({ dcId, id }),
  }),
  create: async ({ dcId, properties }) => basicCRUDAction({
    action: ACTIONS_TYPES.APPLICATION_LOAD_BALANCER.CREATE,
    apiResult: service.applicationLoadbalancer.create({ dcId, properties }),
  }),
  update: async ({ dcId, id, properties }) => basicCRUDAction({
    action: ACTIONS_TYPES.APPLICATION_LOAD_BALANCER.UPDATE,
    apiResult: service.applicationLoadbalancer.update({ dcId, id, properties }),
  }),
  delete: async ({ dcId, id }) => basicCRUDAction({
    action: ACTIONS_TYPES.APPLICATION_LOAD_BALANCER.DELETE,
    apiResult: service.applicationLoadbalancer.delete({ dcId, id }),
  }),
  getAllForwardingRules: async ({ dcId, id }) => hotGetAction({
    action: ACTIONS_TYPES.APPLICATION_LOAD_BALANCER.GET_ALL_FORWARDING_RULE,
    apiResult: service.applicationLoadbalancer.getAllForwardingrule({ dcId, id }),
    isRetrieveItems: true,
  }),
  getForwardingRule: async ({ dcId, forwardingRuleId, id }) => hotGetAction({
    action: ACTIONS_TYPES.APPLICATION_LOAD_BALANCER.GET_FORWARDING_RULE,
    apiResult: service.applicationLoadbalancer.getForwardingrule({ dcId, forwardingRuleId, id }),
  }),
  createForwardingRule: async ({ dcId, id, properties }) => basicCRUDAction({
    action: ACTIONS_TYPES.APPLICATION_LOAD_BALANCER.CREATE_FORWARDING_RULE,
    apiResult: service.applicationLoadbalancer.createForwardingrule({ dcId, id, properties }),
  }),
  updateForwardingRule: async ({
    albId, dcId, id, properties,
  }) => basicCRUDAction({
    action: ACTIONS_TYPES.APPLICATION_LOAD_BALANCER.UPDATE_FORWARDING_RULE,
    apiResult: service.applicationLoadbalancer.updateForwardingrule({
      albId, dcId, id, properties,
    }),
  }),
  partiallyUpdateForwardingRule: async ({
    dcId, forwardingRuleId, id, properties,
  }) => basicCRUDAction({
    action: ACTIONS_TYPES.APPLICATION_LOAD_BALANCER.PARIALLY_UPDATE_FORWARDING_RULE,
    apiResult: service.applicationLoadbalancer.partiallyUpdateForwardingRule({
      dcId, forwardingRuleId, id, properties,
    }),
  }),
  deleteForwardingRule: async ({ dcId, forwardingRuleId, id }) => basicCRUDAction({
    action: ACTIONS_TYPES.APPLICATION_LOAD_BALANCER.DELETE_FORWARDING_RULE,
    apiResult: service.applicationLoadbalancer.deleteForwardingrule({ dcId, forwardingRuleId, id }),
  }),
};

export default applicationloadbalancers;
